var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
const AUTH_FORMS = {
  AU: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/en-AU/card_on_file_authorisation_form-0ebae40d63ac0688cb92f94c8e67f539f67fafa1f75c74935fc0391bf024c9e6.pdf'
  },
  US: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/en-US/card_on_file_authorization_form-ac8f3da887e950384a9514245d23c485561a976005dc37471a86ab446c1b482b.pdf',
    es: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/es-US/card_on_file_authorization_form_2022-d8b42aaf96acf1bb802df1b90f7645f21929263e6755f66864a1ce4366f0b0a6.pdf'
  },
  CA: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/en-CA/card_on_file_authorization_form-e2ebdd8b518346857e38f0f437ac122f9d87af9e77b4fcab206cda410c8d3b79.pdf',
    fr: "https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/fr-CA/formulaire-d'autorisation-de-carte-de-credit-79e25616c60e33f4af742c6381ed675301cb80ee82a614d11488f2cdcba5c996.pdf"
  },
  ES: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/es-ES/formulario-de-autorizacione-de-uso-de-la-tarjeta-de-credito_2021-2b34be429452fc7955c17089513930e2fb9a52378307f8633b1a6056cc068c83.pdf',
    ca: "https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/ca-ES/formulari-d'autoritzacio-d'us-de-la-targeta-de-credit-9c9a1b427b04e61b50ff019834c6dd7b5171be1efbbdba2924bc521c06b2bdb7.pdf"
  },
  FR: {
    default: "https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/fr-FR/formulaire-d'autorisation-de-carte-de-credit_2021_fr-FR-96c70b562ad2b4821145b0463a99ccf3a9326e54c67f81f4554732a4cc8fdf1c.pdf"
  },
  GB: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/en-GB/card_on_file_authorisation_form-27cc5cd12c413d66422ddb421dc9072320a1cd10c811adf962f428e78e1da627.pdf'
  },
  IE: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/en-IE/card_on_file_authorisation_form-75a03459e7cca36940be0839066c4d113c78609bb661e5394ff139c9d4185d92.pdf'
  },
  JP: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/ja-JP/card_on_file_authorization_form-e07f11125fd304d5b9ce844cb5d157dd938608a87609ee2a0823bfd11baf2088.pdf'
  },
  PT: {
    default: 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/directory/pdfs/pt-PT/card_on_file_authorization_form_2022-600b4d2818228a2f68a31c9d2ae524c105e1037767ff6f8675398ab7c85af437.pdf'
  }
};

/**
 * Since these forms are legal documents, we lookup by *merchant* country first then check for requested browser language.
 */
let CardOnFileAuthorizationFormUrl = (_class = class CardOnFileAuthorizationFormUrl extends Helper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
  }
  compute() {
    const countryForms = AUTH_FORMS[this.userInfo.countryCode] || AUTH_FORMS.US;
    const lang = this.userInfo.browserLanguage.slice(0, 2);
    return countryForms[lang] || countryForms.default;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CardOnFileAuthorizationFormUrl as default };